<template>
    <v-layout row wrap align-content-start>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary headline white--text" v-if="!dashboardMode">
                    Notifications
                </v-card-title>
                <v-card-title class="primary headline white--text" v-if="dashboardMode">
                    FDD alert list
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs1>
                        <value-box
                                :value="this.$store.getters.notificationCount"
                                icon=""
                                use-int
                                :title="' Total'">
                        </value-box>
                    </v-flex>
                    <v-flex xs1>
                        <value-box
                                :value="this.$store.getters.recentNotificationsCount"
                                icon=""
                                use-int
                                :title="' Unack : '">
                        </value-box>
                    </v-flex>

                    <v-flex xs1>
                        <value-box
                                :value="this.$store.getters.lowSeverityNotificationsCount"
                                icon=""
                                use-int
                                :title="' Low'">
                        </value-box>
                    </v-flex>
                    <v-flex xs1>
                        <value-box
                                :value="this.$store.getters.mediumSeverityNotificationsCount"
                                icon=""
                                use-int
                                :title="' Medium'">
                        </value-box>
                    </v-flex>
                    <v-flex xs1>
                        <value-box
                                :value="this.$store.getters.highSeverityNotificationsCount"
                                icon=""
                                use-int
                                :title="' High'">
                        </value-box>
                    </v-flex>
                    <v-flex xs1>
                        <value-box
                                :value="this.$store.getters.criticalSeverityNotificationsCount"
                                icon=""
                                use-int
                                :title="' Critical'">
                        </value-box>
                    </v-flex>
                    <v-flex xs3>
                        <v-switch class="ml-4" v-model="showRecent" label="Show Unack Notifications Only"></v-switch>
                    </v-flex>
                    <v-flex xs3>
                        <v-text-field class="mr-4" clearable v-model="search" type="text" label="Keyword filter"></v-text-field>
                        <severity-selector class="mr-4" clearable v-model="severity" label="Severity filter"></severity-selector>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="exportNotification">
                        <v-icon small class="mr-2">fa-download</v-icon>
                        Download
                    </v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-data-table
                            :headers="headers"
                            disable-initial-sort
                            :items="items"
                            class="elevation-1"
                            :pagination.sync="pagination"
                            :search="search"
                            :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    >
                        <template v-slot:items="props">
                            <td @click="callDialog(props.item)">{{ props.item.title }}</td>
                            <td class="text-xs-left">{{ props.item.equip }}</td>
                            <td class="text-xs-left" v-if="!dashboardMode">{{ props.item.equipType }}</td>
                            <td class="text-xs-left" v-if="!dashboardMode">{{ props.item.topic }}</td>
                            <td class="text-xs-left" v-if="!dashboardMode">{{ props.item.floor }}</td>
                            <td class="text-xs-left caption" v-if="!dashboardMode">{{ props.item.description }}</td>
                            <td class="text-xs-left" v-if="!dashboardMode">
                                <ul v-if="props.item.recommendedActions">
                                    <li v-for="i in props.item.recommendedActions.split('\n')">{{i}}</li>
                                </ul>
                            </td>
                            <td class="text-xs-left">{{props.item.startDate}}</td>
                            <td class="text-xs-left">{{props.item.endDate}}</td>
                            <td class="text-xs-left">
                                <severity-chip :value="props.item.severity"></severity-chip>
                            </td>
                            <td class="text-xs-center">
                                <template v-if="$can('update', 'Notification')">
                                    <template v-if="!props.item.acknowledged">
                                        <v-btn icon
                                               @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=true;">
                                            <v-icon color="warning">fa-bell</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-else>
                                        <v-btn icon
                                               @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=false;">
                                            <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                        </v-btn>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="!props.item.acknowledged">
                                        <v-icon color="warning">fa-bell</v-icon>
                                    </template>
                                    <template v-else>
                                        <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                    </template>
                                </template>
                            </td>
                            <td class="justify-center layout px-0">
                                <v-icon small class="mr-2" @click="callDialog(props.item)">
                                    fa-info
                                </v-icon>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on"
                                                small
                                                class="mr-2"
                                                @click="callMaintenanceDialog(props.item)"
                                        >
                                            fa-notes-medical
                                        </v-icon>
                                    </template>
                                    <span>Add maintenance record </span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on"
                                                small
                                                class="mr-2"
                                                @click="jumpToLink(props.item)"
                                        >
                                            fa-chart-line
                                        </v-icon>
                                    </template>
                                    <span>View chart </span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on"
                                                small
                                                @click="jumpToMR(props.item)"
                                        >
                                            fa-clipboard-list
                                        </v-icon>
                                    </template>
                                    <span>View maintenanace records for this period </span>
                                </v-tooltip>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <span>No Result</span>
                            <v-switch v-model="showRecent" label="Show Recent Notifications Only"></v-switch>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-dialog v-model="dialog" max-width="800">
            <v-card>
                <v-card-title class="primary white--text title">
                    {{currentItem.title}}
                </v-card-title>
                <v-card-text>
                    <p class="headline">
                        Equipment : {{currentItem.equip}}
                    </p>
                    <p>
                        {{currentItem.description}}
                    </p>
                    <p>
                        Occured between {{currentItem.startDate.replace('T',' ')}} and
                        {{currentItem.endDate.replace('T',' ')}}
                    </p>
                </v-card-text>
                <v-divider v-if="currentItem.recommendedActions"></v-divider>
                <v-card-text v-if="currentItem.recommendedActions">
                    <p class="headline">
                        <v-icon>fa-shoe-prints</v-icon>
                        Recommended Actions
                    </p>
                    <ul v-if="currentItem.recommendedActions">
                        <li v-for="i in currentItem.recommendedActions.split('\n')">
                            {{i}}
                        </li>
                    </ul>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" round @click="callMaintenanceDialog(currentItem)">
                        <v-icon class="mr-2">fa-notes-medical</v-icon>
                        Add Maintenance Record
                    </v-btn>
                    <v-btn class="accent" round @click="jumpToLink(currentItem)">
                        <v-icon class="mr-2">fa-chart-line</v-icon>
                        View Chart
                    </v-btn>
                    <v-btn class="accent" round @click="dialog = false">
                        Cancel
                    </v-btn>
                </v-card-actions>
                <fault-record-dialog v-model="maintenanceDialog" :item="maintenanceItem"></fault-record-dialog>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import ValueBox from '@/components/ValueBox'
    import FaultRecordDialog from '../components/FaultRecordDialog'
    import _ from 'lodash'
    import SeverityChip from '../components/SeverityChip'
    import {putNotification} from '../helper'
    import {exportCSV} from '../tocsv'
    import SeveritySelector from "../components/SeveritySelector";

    export default {
        props: {
            dashboardMode: {type: Boolean, default: false}
        },
        name: 'Notifications',
        components: {SeverityChip, FaultRecordDialog, ValueBox,SeveritySelector},
        data() {
            return {
                dialog: false,
                pagerCorrected:0,
                maintenanceDialog: false,
                maintenanceItem: null,
                showRecent: true,
                pagination:{
                    descending:_.get(this.$route.query, 'descending', false),
                    page:parseInt(_.get(this.$route.query, 'page', 1)),
                    rowsPerPage:parseInt(_.get(this.$route.query, 'rowsPerPage', 10)),
                    sortBy:_.get(this.$route.query, 'sortBy', null),
                },
                originalPagination:{
                    descending:_.get(this.$route.query, 'descending', false),
                    page:parseInt(_.get(this.$route.query, 'page', 1)),
                    rowsPerPage:parseInt(_.get(this.$route.query, 'rowsPerPage', 10)),
                    sortBy:_.get(this.$route.query, 'sortBy', null),
                },
                search: '',
                severity:null,
                syncPage:false,
                currentItem: {
                    icon: 'fa-bell',
                    title: 'Condenser Cleaning Required in Chiller 1',
                    equip: 'Chiller 1',
                    startDate: '',
                    endDate: '',
                    to: {
                        path: '/sensors',
                        query: {
                            onOnly: true,
                            variableX: 'Cond_Approach',
                            variableY: 'Cond_Approach',
                            rangeStart: '2018-01-01',
                            rangeEnd: '2018-06-30',
                            equipment: 'Chiller 1'
                        }
                    },
                    description: "Condenser Approach High in Chiller 1",
                    recommendedActions: [
                        'Clean Condenser Tubes',
                        'Check Condenser Water Pumps',
                    ].join('\n')
                },
            }
        },
        watch: {
            pagination () {
                if(this.syncPage){
                    this.updateQueryString()
                }
            },
        },
        computed: {
            items() {
                let items=[];
                if (this.showRecent) {
                    items= _.sortBy(this.$store.getters.recentNotifications, ['endDate']).reverse()
                } else {
                    items= _.sortBy(this.$store.state.notificationStore.notifications, ['endDate']).reverse()
                }
                if (!this.severity||this.severity==""){
                    return items
                }  else {
                    let me=this;
                    return items.filter(x=>x.severity==me.severity)
                }

            },
            headers() {
                if (this.dashboardMode) {
                    return [
                        {
                            text: 'Alerts',
                            align: 'left',
                            sortable: true,
                            value: 'title'
                        },
                        {text: 'Equipment', value: 'equip'},
                        {text: 'Start Date', value: 'startDate'},
                        {text: 'End Date', value: 'endDate'},
                        {text: 'Severity', value: 'severity'},
                        {text: 'Acknowledged', value: 'acknowledged'},
                        {text: 'Actions', value: 'name', sortable: false}
                    ]
                } else {
                    return [
                        {
                            text: 'Alerts',
                            align: 'left',
                            sortable: true,
                            value: 'title'
                        },
                        {text: 'Equipment', value: 'equip'},
                        {text: 'Equipment Type', value: 'equipType',sortable: true},
                        {text: 'Topic', value: 'topic',sortable: true},
                        {text: 'Floor', value: 'floor',sortable: true},
                        {text: 'Description', value: 'description'},
                        {text: 'Recommended Actions', value: 'recommendedActions'},
                        {text: 'Start Date', value: 'startDate'},
                        {text: 'End Date', value: 'endDate'},
                        {text: 'Severity', value: 'severity'},
                        {text: 'Acknowledged', value: 'acknowledged'},
                        {text: 'Actions', value: 'name', sortable: false}
                    ]
                }

            }
        },
        mounted() {
            this.$store.dispatch('refreshNotification', this.$store.state.pointsListStore.pointsList.facility_name).then(
                ()=>{
                    setTimeout(()=>{
                        this.pagination={...this.originalPagination}
                        this.syncPage=true
                    },10)
                }
            )
        },
        methods: {
            async trigger(id, state) {
                await putNotification(
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'notification_id': id,
                        'show_flag': state
                    }
                )
            },
            exportNotification() {
                exportCSV(this.items)
            },
            getMaintenanceItem(item) {
                let itemUrlObj=this.getItemUrl(item)
                return {
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    equipment: item['equip'],
                    maintenance_date_from: item['startDate'],
                    maintenance_date_to: item['endDate'],
                    severity: item['severity'],
                    maintenance_text: 'Recommended Actions: \n\n' + item['recommendedActions'],
                    maintenance_label: item['description'],
                    url: this.$router.resolve(itemUrlObj).href,
                    is_fixed: false,
                    notification_id: item['notification_id'],
                    maintenance_id: null
                }
            },
            callMaintenanceDialog(item, dialogOpen = true) {
                this.maintenanceItem = this.getMaintenanceItem(item)
                this.maintenanceDialog = dialogOpen
            },
            updateQueryString () {
                if(this.$router.currentRoute.name==="notifications"){
                    this.$router.replace({
                        path: '/notifications',
                        query: {
                            ...this.pagination
                        }
                    }).catch(err => {})
                }
            },
            callDialog(item) {
                this.dialog = true
                this.currentItem = item
            },
            getItemUrl(item){
                let output = null;
                if (item.title.substring(0,7) === "Anomaly") {
                    output = {
                        path: '/modelsummary',
                        query: {
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipment: item.equip
                        }
                    }
                } else {
                    output = {
                        path: '/fault-analysis',
                        query: {
                            relevantVariables: item.to.query.variableX,
                            faultName: item.title,
                            faultDesc: item.description,
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipmentName: item.equip
                        }
                    }
                }
                return output
            },
            jumpToLink(item) {
                let output=this.getItemUrl(item)
                window.open(this.$router.resolve(output).href)
                // this.$store.dispatch('updateMaintenanceItem', this.getMaintenanceItem(item))
                // this.$router.push(item.to)
            },
            jumpToMR(item) {
                this.$router.push({
                    path:"/maintenancerecord",
                    query:{
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                    }
                })

            },
        }
    }
</script>

<style scoped>

</style>
